import {currencyFormatter, rupiah, formatTime} from 'utils/formatter'
import styles from './ShiftDetailTotalIncome.css'

class ShiftDetailTotalIncome extends React.Component {
  constructor (props) {
    super(props)
    this.state = {collapseIncome: false}
  }
  componentWillReceiveProps (nextProps) {
    this.setState({collapseIncome: false})
  }
  render () {
    let {shift} = this.props
    return (<div className='row'>
      <div className='col-sm-12'>
        {shift.total_income <= 0 && <div className='form-group col-sm-12 label-section' id='collapsibleIncome'>
          <a className='collapsed disable'>
            <label>Total Income</label>
            <div className='pull-right'>Rp. 0</div>
          </a>
        </div>}
        {shift.total_income > 0 && <div className='form-group col-sm-12 label-section' id='collapsibleIncome'>
          <a className={`${!this.state.collapseIncome ? 'collapsed' : ''}`} onClick={this._onClickCollapseIncomeLink}>
            <label>Total Income</label>
            <div className='pull-right'>{currencyFormatter(shift.total_income)}</div>
          </a>
          {this.state.collapseIncome && <div id='collapseIncome'>
            <ul>
              {shift.shift_details.map((detail, idx) => {
                return (detail.type === 'Income' &&
                <li key={idx}>
                  <label className={`detail-description ${styles['total-income-label']}`}>{formatTime(detail.created_at)} - {detail.description}</label>
                  <div className={`${styles['total-income-amount']}`}>
                    <span className='pull-right'>{rupiah(detail.amount)}</span>
                  </div>
                </li>)
              })}
            </ul>
          </div>}
        </div>}
      </div>
    </div>)
  }
  _onClickCollapseIncomeLink = () => {
    this.setState({collapseIncome: !this.state.collapseIncome})
  }
}

ShiftDetailTotalIncome.propTypes = {
  shift: React.PropTypes.object
}
export default ShiftDetailTotalIncome



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailTotalIncome/ShiftDetailTotalIncome.js